export function SummaryCard({ title, value, bgColor, textColor, borderColor }) {
  return (
    <div className={`text-center p-3 ${bgColor} rounded border ${borderColor}`}>
      <div className={`text-xs ${textColor} font-medium mb-1`}>{title}</div>
      <div className={`text-2xl font-bold ${textColor}`}>{value}</div>
    </div>
  );
}